var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flag == _vm.index && _vm.detailShow
    ? _c("div", { staticClass: "sync-detail" }, [
        _c(
          "div",
          {
            staticClass: "sync-title",
            class: _vm.itemSyncDetail.status == "Done" ? "team-top" : ""
          },
          [
            _vm._v(
              "\r\n       " +
                _vm._s(_vm.$t("language.popup.transferDetails")) +
                "\r\n    "
            )
          ]
        ),
        _vm._v(" "),
        _vm.itemSyncDetail.status == "Done" ||
        (_vm.itemSyncDetail.status == "Normal" && _vm.itemSyncDetail.result)
          ? _c(
              "div",
              {
                class:
                  _vm.itemSyncDetail.status == "Done" ||
                  (_vm.itemSyncDetail.status == "Normal" &&
                    _vm.itemSyncDetail.result)
                    ? "team-top1"
                    : ""
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "sync-all-line",
                    staticStyle: { "margin-top": "10Px" }
                  },
                  [
                    _vm.showStatus(_vm.itemSyncDetail) == "threadSuccess"
                      ? _c("span", { staticClass: "sync-column-left" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("language.common.result")) +
                              ":" +
                              _vm._s(_vm.$t("language.common.success")) +
                              "\r\n               \r\n             "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(_vm.itemSyncDetail) == "threadFailure"
                      ? _c("span", { staticClass: "sync-column-left" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.common.result")) +
                              ":" +
                              _vm._s(_vm.$t("language.common.failure")) +
                              "\r\n               \r\n             "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(_vm.itemSyncDetail) == "particalStatus"
                      ? _c("span", { staticClass: "sync-column-left" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.common.result")) +
                              ":" +
                              _vm._s(_vm.$t("language.common.patial")) +
                              "\r\n               \r\n             "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showStatus(_vm.itemSyncDetail) == "threadCancel"
                      ? _c("span", { staticClass: "sync-column-left" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.common.result")) +
                              ":" +
                              _vm._s(_vm.$t("language.common.canceled")) +
                              "\r\n               \r\n             "
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "sync-line" }, [
                  _c("span", { staticClass: "sync-column-left" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.fileProcess")) +
                        ":\r\n                 "
                    ),
                    _vm.itemSyncDetail.lastLog
                      ? _c("span", [
                          _vm._v(
                            "\r\n                " +
                              _vm._s(
                                _vm.itemSyncDetail.lastLog.readyTranFileCount
                              ) +
                              "/" +
                              _vm._s(
                                _vm.itemSyncDetail.lastLog.totalFileCount
                              ) +
                              "\r\n                "
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sync-line" }, [
                  _c("span", { staticClass: "sync-column-left" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.dataProcess")) +
                        ":\r\n            "
                    ),
                    _vm.itemSyncDetail.lastLog
                      ? _c("span", [
                          _vm._v(
                            "\r\n                " +
                              _vm._s(
                                _vm._f("formatByte")(
                                  _vm.itemSyncDetail.lastLog
                                    .fileTotalReadedBytes
                                )
                              ) +
                              "/" +
                              _vm._s(
                                _vm._f("formatByte")(
                                  _vm.itemSyncDetail.lastLog.totalBytes
                                )
                              ) +
                              "\r\n                "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "sync-column-right" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.endTime")) +
                        ":\r\n                "
                    ),
                    _c("span", [
                      _vm._v(
                        "\r\n                " +
                          _vm._s(
                            _vm._f("getEndTime")(_vm.itemSyncDetail.lastLog)
                          ) +
                          "\r\n                "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sync-line" }, [
                  _c("span", { staticClass: "sync-column-left" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.startTime")) +
                        ": " +
                        _vm._s(_vm.itemSyncDetail.lastLog.taskStartTimeStr)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "sync-column-right" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.executedTimes")) +
                        ": " +
                        _vm._s(_vm.itemSyncDetail.runCount)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sync-line" }, [
                  _c("span", { staticClass: "sync-column-left" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.averageRateSpecial")) +
                        ": " +
                        _vm._s(
                          _vm._f("formatByteSpeed")(
                            _vm.itemSyncDetail.lastLog.fileTotalReadedBytes /
                              (_vm.itemSyncDetail.lastLog.taskElaspedTimeLong /
                                1000)
                          )
                        )
                    )
                  ])
                ])
              ]
            )
          : _c("div", { staticClass: "sync-detail-two" }, [
              _c("div", { staticClass: "sync-all-line" }, [
                _c("span", { staticClass: "sync-column-left" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.fileProcess")) +
                      ":\r\n                "
                  ),
                  _vm.itemSyncDetail.syncDetail &&
                  _vm.itemSyncDetail.syncDetail.state2.status != 0 &&
                  (_vm.itemSyncDetail.syncDetail.state2.readyTranFileCount ||
                    _vm.itemSyncDetail.syncDetail.state2.readyFindFileCount)
                    ? _c("span", [
                        _vm._v(
                          "\r\n                " +
                            _vm._s(
                              _vm.itemSyncDetail.syncDetail.state2
                                .readyTranFileCount
                            ) +
                            "/" +
                            _vm._s(
                              _vm.itemSyncDetail.syncDetail.state2
                                .readyFindFileCount
                            ) +
                            "\r\n                "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sync-line" }, [
                _c("span", { staticClass: "sync-column-left" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.dataProcess")) +
                      ":\r\n                "
                  ),
                  _vm.itemSyncDetail.syncDetail.state2 &&
                  _vm.itemSyncDetail.syncDetail.state2.status != 0 &&
                  (_vm.itemSyncDetail.syncDetail.state2.readedBytes ||
                    _vm.itemSyncDetail.syncDetail.state2.totalBytes)
                    ? _c("span", [
                        _vm._v(
                          "\r\n                " +
                            _vm._s(
                              _vm._f("formatByte")(
                                _vm.itemSyncDetail.syncDetail.state2.readedBytes
                              )
                            ) +
                            "/" +
                            _vm._s(
                              _vm._f("formatByte")(
                                _vm.itemSyncDetail.syncDetail.state2.totalBytes
                              )
                            ) +
                            "\r\n                "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "sync-column-right" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.progress")) +
                      ":\r\n                "
                  ),
                  _vm.itemSyncDetail.syncDetail.state2 &&
                  _vm.itemSyncDetail.syncDetail.state2.percent
                    ? _c("span", [
                        _vm.itemSyncDetail.syncDetail.state2.percent
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.itemSyncDetail.syncDetail.state2
                                      .percent + "%"
                                  )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.itemSyncDetail.syncDetail.state2.percent
                          ? _c("span", [_vm._v("0%")])
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sync-line" }, [
                _c("span", { staticClass: "sync-column-left" }, [
                  _vm._v(_vm._s(_vm.$t("language.common.startTime")) + ":"),
                  _vm.itemSyncDetail.syncDetail.state2
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("transferTime")(
                              _vm.itemSyncDetail.syncDetail.state2
                                .taskStartTimeLong
                            )
                          ) + " "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "sync-column-right" }, [
                  _vm._v(_vm._s(_vm.$t("language.common.currentRate")) + ": "),
                  _vm.itemSyncDetail.syncDetail.state2 &&
                  _vm.itemSyncDetail.syncDetail.state2.status > 1
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.itemSyncDetail.syncDetail.state2.speed)
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.itemSyncDetail.syncDetail &&
              _vm.itemSyncDetail.syncDetail.entities
                ? _c(
                    "div",
                    {
                      staticClass: "detail-three",
                      staticStyle: { position: "relative", top: "5px" },
                      style: { height: _vm.getHeight() }
                    },
                    _vm._l(_vm.itemSyncDetail.syncDetail.entities, function(
                      item,
                      index
                    ) {
                      return _c(
                        "div",
                        { key: index, staticClass: "sync-line" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "sync-column-left transfering-file-line",
                              attrs: { title: _vm.getTitle(item) }
                            },
                            [
                              _vm._v(
                                "\r\n                " +
                                  _vm._s(_vm._f("getCatalog")(item.fileNode)) +
                                  "\\" +
                                  _vm._s(item.filename) +
                                  "\r\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.isVip()
                            ? _c("span", [
                                item.rate == -1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "sync-column-right transfering-file-line upgradeMulti",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.switchToPay()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.common.upgradeMulti"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.rate != -1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "sync-column-right transfering-file-line"
                                      },
                                      [_vm._v(_vm._s(item.rate) + "%")]
                                    )
                                  : _vm._e()
                              ])
                            : _c("span", [
                                item.rate && item.rate != -1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "sync-column-right transfering-file-line"
                                      },
                                      [_vm._v(_vm._s(item.rate) + "%")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "sync-column-right transfering-file-line"
                                      },
                                      [_vm._v("0%")]
                                    )
                              ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "sync-line" }, [
                _c("div", {
                  staticClass: "icon-util shop-cart shop-cart-position"
                }),
                _vm._v(" "),
                !_vm.isVip()
                  ? _c(
                      "span",
                      {
                        staticClass: "transfer-line-des",
                        staticStyle: { "line-height": "40Px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.common.noVip")))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isVip()
                  ? _c(
                      "span",
                      {
                        staticClass: "transfer-line-des",
                        staticStyle: { "line-height": "40Px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.common.vipThanks")))]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              !_vm.isVip()
                ? _c("div", { staticClass: "sync-line" }, [
                    _c(
                      "button",
                      {
                        staticClass: "upgrade-now",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.switchToPay()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.common.upgradeNow")))]
                    )
                  ])
                : _vm._e()
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-696d90e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696d90e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_businessThreads_detail.vue
// module id = null
// module chunks = 